module.exports = __webpack_public_path__ + "media/images/icons/map-6a3ba2ad2a27976fa20228f62ca1bc44.svg";